export const formatPrice = numCents => '$' + parseFloat(numCents / 100).toFixed(2);